<script setup>
import moneyIcon from '../assets/money-icon.png'

defineProps({
  size: {
    type: String,
    default: 'md',
    validator: (v) => ['sm', 'md', 'lg'].includes(v)
  }
})
</script>

<template>
  <img
    :src="moneyIcon"
    alt=""
    class="money-input-prefix"
    :class="`money-input-prefix--${size}`"
    aria-hidden="true"
  />
</template>

<style scoped>
.money-input-prefix {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  object-fit: contain;
  pointer-events: none;
  z-index: 1;
}

.money-input-prefix--sm {
  width: 14px;
  height: 14px;
}

.money-input-prefix--md {
  width: 18px;
  height: 18px;
}

.money-input-prefix--lg {
  width: 20px;
  height: 20px;
}
</style>
